// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1iMtM","row":"styles_row__Shmd6"};